module.exports = __webpack_public_path__ + "static/job_ad_thumbnail-38fa7c20bd2465aa1e908d9a97b131ab.png";